import React from 'react'

import RoundBlueButton from '../BorderButton/round-blue-button'
import { getDmp, getDmpProduct } from '../../lib/format-dmps'

import { InputGroup } from 'reactstrap'
import CurrencySelector from '../../containers/add-license/currency-selector'
import { formatCurrency } from '../../lib/format-number'

const SaveButton = ({ onClick, disabled }) => (
    <RoundBlueButton data-tip data-for="saveBtnTooltip" disabled={disabled} onClick={onClick} icon={<i className="fa fa-floppy-o" />} />
)
const RemoveButton = ({ onClick, disabled }) => (
    <RoundBlueButton data-tip data-for="deleteBtnTooltip" disabled={disabled} onClick={onClick} icon={<i className="fa fa-trash" />} />
)

export default class Row extends React.Component {
    // lookupers
    getPartnerName(partnerId) {
        if (Array.isArray(this.props.partners)) {
            let obj = this.props.partners.find(it => it.partnerId === partnerId)
            if (obj) return obj['friendlyName']
            return ''
        } /*else {
            return this.props.partners['friendlyName']
        }*/
    }

    //const Row = ({ row, index, this.props.onchange, onSave, onRemove, partners, dmps, dmpProducts }) => (
    render() {
        return (
            <tr>
                {/*
                <td className="audience-list audience-list--audience">
                    {!this.props.row.new && (
                        <div>
                            {this.props.editMode === false && this.getPartnerName(this.props.row.partnerId) + ' (' + this.props.row.partnerId + ')'}
                            {this.props.editMode && this.getPartnerName(this.props.row.partnerId)}
                        </div>
                    )}

                    {this.props.row.new && (
                        <select
                            disabled={!this.props.row.new}
                            className="form-control"
                            id="partnerId"
                            value={this.props.row.partnerId}
                            onChange={event => this.props.onchange(event, this.props.row, this.props.index)}>
                            {this.props.partners &&
                                this.props.partners.map(it => {
                                    return (
                                        <option key={it.partnerId} value={it.partnerId}>
                                            {it.friendlyName} ({it.partnerId})
                                        </option>
                                    )
                                })}
                        </select>
                    )}
                </td>
                */}
                <td className="audience-list audience-list--audience">
                    {!this.props.row.new && getDmp(this.props.row.dmp)}
                    {this.props.row.new && (
                        <select
                            disabled={!this.props.row.new}
                            className="form-control"
                            id="dmp"
                            value={this.props.row.dmp}
                            onChange={event => this.props.onchange(event, this.props.row, this.props.index)}>
                            {this.props.dmps &&
                                this.props.dmps.map(it => {
                                    return (
                                        <option key={it.dmp} value={it.dmp}>
                                            {it.dmpName}
                                        </option>
                                    )
                                })}
                        </select>
                    )}
                </td>
                <td className="audience-list audience-list--audience">
                    {!this.props.row.new && getDmpProduct(this.props.row.product)}
                    {this.props.row.new && (
                        <select
                            disabled={!this.props.row.new}
                            className="form-control"
                            id="product"
                            value={this.props.row.product}
                            onChange={event => this.props.onchange(event, this.props.row, this.props.index)}>
                            {this.props.dmpProducts &&
                                this.props.dmpProducts.map(it => {
                                    return (
                                        <option key={it.product} value={it.product}>
                                            {it.productName}
                                        </option>
                                    )
                                })}
                        </select>
                    )}
                </td>

                <td className="audience-list audience-list--size">
                    {this.props.editMode  && (
                        <input
                            type="number"
                            max="100.0"
                            min="0.0"
                            className="form-control"
                            id="revShare"
                            value={this.props.row.revShare}
                            onChange={event => this.props.onchange(event, this.props.row, this.props.index)}
                        />
                    )}
                    {!this.props.editMode && <span>{this.props.row.revShare}</span>}
                </td>
                <td className="audience-list audience-list--size">
                    {this.props.editMode  && (
                        <InputGroup>
                            <input
                                type="text"
                                max="100.0"
                                min="0.0"
                                id="minPrice"
                                className="form-control"
                                value={this.props.row.minPrice}
                                onChange={event => this.props.onchange(event, this.props.row, this.props.index)}
                            />
                            <CurrencySelector
                                direction="up"
                                currency={this.props.row.currency}
                                disabled={!this.props.row.new}
                                onChangeCurrency={event => this.props.onchange(event, this.props.row, this.props.index, 'currency')}
                            />
                        </InputGroup>
                    )}
                    {!this.props.editMode && <span>{formatCurrency(parseFloat(this.props.row.minPrice), this.props.row.currency)}</span>}
                </td>

                {this.props.editMode && (
                    <td className="audience-list audience-list--edit">
                        <div className="action-wrapper" style={{ justifyContent: 'flex-end' }}>
                            <SaveButton onClick={() => this.props.onSave(this.props.row, this.props.index)} />
                            <RemoveButton onClick={() => this.props.onRemove(this.props.row, this.props.index)} />
                        </div>
                    </td>
                )}
            </tr>
        )
    }
}
